import { ApiClient } from "./api-client";

export function getRoomType(id) {
  return ApiClient.getInstance().get(`/room-type/${id}`).catch((error) => {
    console.error('Error fetching room type by id:', error);
    throw error;
  });
}

export function getRoomTypes() {
  return ApiClient.getInstance().get('/room-type').catch((error) => {
    console.error('Error fetching room types:', error);
    throw error;
  });
}